import React, { Fragment, useEffect, useState } from "react";
import DualListBox from "../../core/BaseComponents/CustomDualList/DualListBox";
import BasicModal from "../../core/BaseComponents/Modal";
import RailConfigPreview from "./RailConfigPreview";
// import { callAPI } from "../../../axios";

const PartnerRails = (props) => {
  const { selectedUtilityFullObject, tabs, defaultValue, masterPartnerList, tabChangeHandler, editPublishUnPublish, setPartnerRailData, onResetHandler, onResetPartner, railName, roomTypes, onSubmitHandler, selectedChannelForYouFullObject, setSelectedPartnerFullObject, selectedHotelServiceFullObject, selectedHotelChannelFullObject, setPayloadPartner } = props;
  const [partnerList, setPartnerList] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([])
  const [initialSelected, setInitialSelected] = useState([]);

  const [previewPartnerRail, setPreviewPartnerRail] = useState([])
  const [selectedPrtnerFullObject, setSelectedPrtnerFullObject] = useState([])

  const [preview, setPreview] = useState(false);

  useEffect(() => {
    if (Array.isArray(defaultValue) && defaultValue.length) {
      const defaultSids = defaultValue.map((item) => item.partnerId);
      const defaultPartners = masterPartnerList?.filter((partnerData) =>defaultSids.includes(partnerData?.sid))
      const sequenceData = defaultPartners?.map((partner)=>({...partner, sequenceNo: defaultValue?.find(def=>def?.partnerId === partner?.sid)?.sequenceNo}))
      const sortedData = sequenceData?.sort((a,b)=>a.sequenceNo - b.sequenceNo)
      setSelectedPrtnerFullObject(sortedData)
      setPreviewPartnerRail(sortedData)
      setInitialSelected(sortedData);
      setPartnerList(
        masterPartnerList?.filter(
          (partnerData) => !defaultSids.includes(partnerData?.sid)
        )
      );
      // setSelectedPartners({partnerIds: defaultSids})
    } else {
      setPartnerList(masterPartnerList);
      setSelectedPrtnerFullObject([])
      setSelectedPartners([])
      setPreviewPartnerRail([])
      setInitialSelected([]);
    }
  }, [defaultValue, masterPartnerList]);

  useEffect(() => {
    if (defaultValue?.length) {
      // localStorage.setItem(
      //   "partnerRailPayload",
      //   JSON.stringify({ partners: defaultValue })
      // );
      setPayloadPartner({ partners: defaultValue })
      setSelectedPartners(defaultValue)
    }
  }, [defaultValue])

  const handleItemsChange = (selected) => {
    // e.preventDefault();
    setSelectedPrtnerFullObject(selected)
    const data = selected?.map((data,index) => ({partnerId:data.sid, sequenceNo:index+1}))
    setSelectedPartners(data)
    setPreviewPartnerRail(data)
  };

  const previewHandler = () => {
    setSelectedPartnerFullObject(selectedPrtnerFullObject)
    setPartnerRailData(selectedPartners)
    // localStorage.setItem(
    //   "partnerRailPayload",
    //   JSON.stringify({ partners: selectedPartners })
    // );
    setPayloadPartner({ partners: selectedPartners })
    setPreview(true)
  }

  const onSaveHandler = () => {
    setSelectedPartnerFullObject(selectedPrtnerFullObject)
    setPartnerRailData(selectedPartners)
    // localStorage.setItem(
    //   "partnerRailPayload",
    //   JSON.stringify({ partners: selectedPartners })
    // );
    setPayloadPartner({ partners: selectedPartners })
    // onSubmitHandler()
    const nextTab = tabs?.find((data)=>data?.railName==="partner")
    if(nextTab?.sequenceNo<5){
      tabChangeHandler(nextTab?.sequenceNo)
    }
    else{
      setPreview(true);
    }
  }

  return (
    <Fragment>
      <DualListBox
        listTitle="List Of Partners"
        selectedListTitle="Selected Partners"
        items={partnerList}
        initialData={initialSelected}
        onChange={(selected) => handleItemsChange(selected)}
      />
      <div className="text-end">
        {editPublishUnPublish && <button
          onClick={onResetPartner}
          type="button"
          className="create-btn ms-2"
        >
          Reset
        </button>}
        <button
          onClick={previewHandler}
          type="button"
          className="create-btn ms-2"
        >
          preview
        </button>
        <button
          onClick={onSaveHandler}
          type="button"
          className="create-btn ms-2"
        >
          {editPublishUnPublish ? "Update" : "Save"}
        </button>
      </div>
      {preview && <BasicModal
        popupOpen={preview}
        bodyMessage={<RailConfigPreview
          setPreview={setPreview}
          // onSubmitHandler={onSubmitHandler}
          // editPublishUnPublish={editPublishUnPublish}
          previewListRowData={{ roomTypes, railName }}
          onCreateRailConfigPreview={true}
          tabs={tabs}
          onResetHandler={onResetHandler}
          previewUtilityData={selectedUtilityFullObject}
          previewPartnerData={previewPartnerRail}
          previewChannelData={selectedChannelForYouFullObject}
          previewHotelServiceData={selectedHotelServiceFullObject}
          previewHotelChannelData={selectedHotelChannelFullObject}
        />}
        popupSize={'col-11 rails-preview'}
        footer={{
          ...(editPublishUnPublish && {
            thirdButton: {
              buttonName: "Reset Rail",
              action: () => onResetHandler(),
            },
          }),
          primaryButton: {
            buttonName: `${editPublishUnPublish ? "Update" : "Create"} Rail`,
            action: () => onSubmitHandler(false),
          },
          secondaryButton: {
            buttonName: "Publish Rail",
            action: () => onSubmitHandler(true)
          }
        }
        }
        popBtnAlignment='justify-content-end'
      />
      }
    </Fragment>
  );
};

export default PartnerRails;
